import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { getOnboardingStatus } from '../api/hydra';
import { IAPIError, IOnBoardingStatusResponse } from "../interfaces/common";

export const onboardingStatusQueryKey = ['onboardingStatus'] as const;

export const useOnboardingStatus = (enabled: boolean):
  UseQueryResult<IOnBoardingStatusResponse, IAPIError> => {
  return useQuery<IOnBoardingStatusResponse, IAPIError>({
    queryKey: onboardingStatusQueryKey,
    enabled,
    queryFn: ({ signal }) => getOnboardingStatus(signal),
  });
};
